/*
 * @Description:
 * @Author: Teemo D
 * @Date: 2021-03-24 14:26:48
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-07 21:03:37
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/tools.ts
 */
import _ from 'lodash';

import {
  hasItemList,
  listPropertyName,
} from 'src/pages/SalesChannelContentEditor/common';
import {
  EnumCollapseId,
  generateBackgroundStyle,
  generateProfileContentManagement,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/common';
import { convertSpecificError } from 'src/constrains/SalesChannelPreviewPageComponents/tools';

import { randomNumber } from 'src/tools/helper';
import { ModuleType } from './common';

import { errCodesMap } from 'src/error/code';
import { linkValidation } from '@/src/constrains/DraggableModules/tools';
// import { validation } from 'src/pages/SalesChannelContentEditor/Components/tools';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
import { generateNoneLinkData } from 'src/constrains/LinkLibrary/tools';

const convertDataFromServerToRedux = (data, isPrimary) => {
  const defaultLinkTo = generateNoneLinkData();

  const {
    featuredProducts,
    salesChannelContent,
    salesChannelName,
    policy,
    backgroundStyle,
    contentUuid,
    uuid,
    hasError: hasErrorCollapse,
    profileContentManagement,
    translationEnabled = false,
  } = _.get(data, 'profilePage') || data;

  const isNew = !uuid;

  const policyItem = (policy || {}).items || [];
  const moduleContentOrder = [];
  const moduleContentStaticConfig = {};
  const moduleContentDynamicConfig = {};
  const collapseOpen = {
    [EnumCollapseId.backgroundStyle]: false,
    [EnumCollapseId.policy]: false,
    [EnumCollapseId.management]: false,
  };
  const collapseErrorMsgDisplay = {
    [EnumCollapseId.backgroundStyle]: { hasError: false, display: !isNew },
    [EnumCollapseId.policy]: { hasError: false, display: !isNew },
    [EnumCollapseId.management]: { hasError: false, display: !isNew },
  };

  const _policy = [
    {
      draggableId: `policy_${randomNumber()}`,
      title: 'Policy 1',
      linkTo: defaultLinkTo,
    },
  ];
  const defaultColor = '#000000';
  policyItem.forEach((item) => {
    const { linkTo } = item;
    if (!linkTo) {
      item.linkTo = defaultLinkTo;
    }
  });

  const _item = _.cloneDeep(featuredProducts);

  const {
    moduleType,
    title,
    products,
    enabled,
    draggableId: draggableIdOld,
  } = featuredProducts || {};
  let { titleTextColor } = featuredProducts || {};
  const draggableId = draggableIdOld || randomNumber();
  if (!titleTextColor) titleTextColor = defaultColor;
  moduleContentOrder.push({
    moduleType,
    draggableId,
    titleTextColor,
    title,
    products,
    enabled,
  });

  const _hasList = hasItemList.includes(moduleType);
  if (isNew) {
    collapseOpen[`module_${moduleType}`] = true;
  } else {
    collapseOpen[`module_${moduleType}`] = false;
  }
  collapseErrorMsgDisplay[`module_${moduleType}`] = {
    hasError: false,
    display: !isNew,
  };
  if (_hasList) {
    const _listName = listPropertyName[moduleType];
    if (_listName) {
      const listValue = (featuredProducts[_listName] || []).map((o) => {
        return { ...o, draggableId: randomNumber() };
      });

      moduleContentDynamicConfig[draggableId] = listValue;
      _item.displayErrorMsg = true;
      delete _item[_listName];
    }
  }

  moduleContentStaticConfig[draggableId] = {
    ...(_item || {}),
    draggableId,
  };

  const _backgroundStyle = generateBackgroundStyle();

  const _a = {
    moduleContentOrder,
    moduleContentStaticConfig,
    moduleContentDynamicConfig,
    collapseOpen,
    contentUuid: contentUuid,
    salesChannelContent,
    salesChannelName,
    policy: policyItem.length ? policyItem : _policy,
    backgroundStyle: {
      image: backgroundStyle?.image,
      backgroundColor:
        backgroundStyle?.backgroundColor || _backgroundStyle.backgroundColor,
      primaryColor:
        backgroundStyle?.primaryColor || _backgroundStyle.primaryColor,
      textColor: backgroundStyle?.textColor || _backgroundStyle.textColor,
      tabColor: backgroundStyle?.tabColor || _backgroundStyle.tabColor,
    },
    profileContentManagement:
      profileContentManagement || generateProfileContentManagement(),
    uuid,
    collapseErrorMsgDisplay,
    translationEnabled,
    ...reduxUpdatedStatusControl,
  };
  if (hasErrorCollapse && !isNew) {
    const { hasError: policyHasError } = validatePolicy(_a.policy, isPrimary);
    if (policyHasError) {
      _a.collapseOpen[EnumCollapseId.policy] = true;
      _a.collapseErrorMsgDisplay[EnumCollapseId.policy].hasError = true;
      _a.collapseErrorMsgDisplay[EnumCollapseId.policy].display = true;
      return _a;
    }
    const { hasError: backgroundStyleErr } = validateImageStateSetting(
      _a.backgroundStyle,
    );
    if (backgroundStyleErr) {
      _a.collapseOpen[EnumCollapseId.backgroundStyle] = true;
      _a.collapseErrorMsgDisplay[EnumCollapseId.backgroundStyle].hasError =
        true;
      _a.collapseErrorMsgDisplay[EnumCollapseId.backgroundStyle].display = true;
      return _a;
    }
  }

  return _a;
};

const convertDataFromReduxToServer = (state) => {
  const _state = _.cloneDeep(state);

  const {
    moduleContentOrder,
    backgroundStyle,
    policy,
    contentUuid,
    uuid,
    profileContentManagement,
  } = _state;

  const moduleTypes = [];
  const policyItem = { items: policy };

  const featuredProducts = { titleTextColor: '' };
  moduleContentOrder.forEach((i) => {
    const { moduleType, titleTextColor } = i;

    moduleTypes.push(moduleType);
    if (moduleType == ModuleType.FeaturedProduct) {
      featuredProducts.titleTextColor = titleTextColor;
    }
  });
  return {
    backgroundStyle,
    policy: policyItem,
    contentUuid,
    featuredProducts,
    moduleTypes: moduleTypes,
    uuid,
    profileContentManagement,
  };
};

export const validatePolicy = (data, isPrimary) => {
  const specificErr = {};
  const generalError = [];

  data.forEach((item, index) => {
    const { title, draggableId, linkTo } = item || {};
    specificErr[`${draggableId}titleError`] = [];
    if (!title) {
      specificErr[`${draggableId}titleError`].push(errCodesMap[999993]);
    }
    if (isPrimary) {
      linkValidation({
        data: linkTo,
        suffixKey: draggableId,
        err: specificErr,
      });
    }
  });
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError,
  };
};

export const validateImageStateSetting = (data) => {
  const specificErr = {};
  const generalError = [];
  const { image } = data;
  if (!(image || {}).uuid) {
    generalError.push(errCodesMap[199221]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError,
  };
};

export { convertDataFromReduxToServer, convertDataFromServerToRedux };
